import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/site/Layout";
import { Canonical } from "@/components/site/Canonical";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import JobDetail from "@/pages/JobDetail";
import JobApply from "@/pages/JobApply";
import AdminStorage from "@/pages/AdminStorage";
import AdminCareers from "@/pages/AdminCareers";
import AmwapSupply from "@/pages/AmwapSupply";
import SupplyProduct from "@/pages/SupplyProduct";
import SupplyCart from "@/pages/SupplyCart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Account from "@/pages/Account";
import Store from "@/pages/Store";
import AdminSupply from "@/pages/AdminSupply";
import AdminInbox from "@/pages/AdminInbox";
function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Canonical />
      <Routes>
        <Route path="/admin/storage" element={<AdminStorage />} />
        <Route path="/admin/careers" element={<AdminCareers />} />
        <Route path="/admin/supply" element={<AdminSupply />} />
        <Route path="/admin/inbox" element={<AdminInbox />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/contact" element={<Navigate to="/contact-us" replace />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/:id" element={<JobDetail />} />
          <Route path="/careers/:id/apply" element={<JobApply />} />
          <Route path="/supply" element={<AmwapSupply />} />
          <Route path="/supply/gear" element={<Store />} />
          <Route path="/supply/cart" element={<SupplyCart />} />
          <Route path="/supply/:id" element={<SupplyProduct />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/account" element={<Account />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
